import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetPasswordUiComponent } from './set-password-ui.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { DirectivesModule } from '../../directives/directives.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";



@NgModule({
  declarations: [SetPasswordUiComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule
  ],
  exports: [SetPasswordUiComponent]
})
export class SetPasswordUiModule { }
